// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackSearchFilteredParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackSearchFiltered";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackSearchFiltered = (
    parameters: PartialSpecific<TrackSearchFilteredParameters, "filter_name"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => ga.util.getEventTrackerHook(ga.track.searchFiltered, parameters, options);

export default useTrackSearchFiltered;
